export const getEnterpriseIntakeDefaultValues = () => ({
  organizationType: "agency",

  fullName: "",
  corporateEmail: "",
  companyName: "",
  jobTitle: "",

  selectedAdleModules: [],
  scopeBrandConfigsCount: "",

  module1MonthlyNewImagesCount: "",
  module1MonthlyImageAnimationsCount: "",
  module1MonthlyVideosCount: "",
  creativesBufferTypes: [],
  creativesBufferPercent: "",
  creativesBufferPercentOther: "",

  module2MonthlyCampaignsCount: "",
  optimizationFrequency: "",

  platformUsersCount: "",
  contractTermMonths: "",

  whiteLabelRequirement: "",

  mediaManagementAddon: "",
  monthlyMediaSpendUsd: "",

  additionalNotes: "",
});

export const enterpriseIntakeDefaultValues = getEnterpriseIntakeDefaultValues();
